import React, {
  useState, useEffect, useCallback, useMemo,
} from 'react';
import * as Styles from './OnboardingHandler.styles';
import useLocale from '@/hooks/useLocale';
import { ChooseDomainStep } from './components/ChooseDomainStep';
import { OtherToolsSuccess } from './components/OtherToolsSuccess';
import { GenericSuccess } from '@/components/FullWidthTemplate/GenericSuccess';
import { SiteBuilderSuccess } from '@/components/FullWidthTemplate/SiteBuilderSuccess';
import { WordPressInstall } from './components/WordPressInstall';
import { ChooseSiteOption } from './components/ChooseSiteOption';
import {
  FLOWS, multiDomainsPlansIds, STEPS,
} from './OnboardingHandler.enum';
import {
  IconAiStar,
  IconArrow, IconButton, IconExternalLink, IconLoading,
  IconPicture, IconGoogleBusiness,
} from 'gatorcomponents';
import { CART_URL, COUNTRY } from '@/config';
import DOMPurify from 'dompurify';
import { useDispatch, useSelector } from 'react-redux';
import {
  domainsActions, gatorProtectActions, onboardingActions, sitesActions,
} from '@/redux/modules';
import {
  ATIVACAO_ALLOW_CHOOSE_TEMP_OWNED_DOMAIN_ENTRADA,
  ATIVACAO_CHOOSE_MIGRATION_STEP,
  ATIVACAO_SITES_ONBOARDING, ATIVACAO_UPDATE_ONBOARDING_FLOW_EVERY_STEP_CHANGE,
  PORTFOLIO_ONBOARDING_HG_BUILDER_PREVIEW,
  ATIVACAO_TRIGGER_GATE_CREATE_SITE_TEMPORARY_DOMAIN,
  MONETIZACAO_DISABLE_TRIAL_GATOR_PROTECT,
} from '@/config/GrowthBook/constants';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import {
  Redirect, useHistory, useParams,
} from 'react-router';
import { getURLCpanel } from '@/config/urls/cpanelUrls';
import { useBlockedWindowModal } from '@/hooks/useBlockedWindowModal';
import { clearOnboarding } from '@/redux/actions/summary';
import HgLogoV2 from '@/media/logo/HgLogoV2';
import WpIaScreen from '@/media/onboarding/wp-ai-success-br.webp';
import WpNormalScreen from '@/media/onboarding/wp-normal-success.webp';
import siteBuilderSuccessBr from '@/media/onboarding/sitebuilder/sitebuilder_success_br.png';
import siteBuilderSuccessEs from '@/media/onboarding/sitebuilder/sitebuilder_success_es.png';
import { isBRServer } from '@/utils/Validators/validation';
import { removeProductDetail } from '@/redux/actions/productDetail';
import { onboardingAnalytics } from '@/analytics/onboarding';
import { DomainNotRegistered } from './components/DomainNotRegistered';
import { useOnboardingActions } from '@/hooks/onboarding/useOnboardingActions';
import { ExternalDomain } from '@/components/OnboardingHandlerComponents/ExternalDomain';
import OtherToolsScreen from '@/media/onboarding/other-tools.webp';
import { ChooseWpMigrationStep } from '@/components/OnboardingHandlerComponents/ChooseWpMigrationStep';
import { WordpressMigration } from '@/pages/WordpressMigration';
import { AiBuilderMyBusiness } from '@/components/OnboardingHandlerComponents/AiBuilderMyBusiness';
import { AiBuilderCreateSite } from '@/components/OnboardingHandlerComponents/AiBuilderCreateSite';
import { AiBuilderWithTemplate } from '@/components/OnboardingHandlerComponents/AiBuilderWithTemplate';
import { SiteBuilderV2 } from '@/components/OnboardingHandlerComponents/SiteBuilderV2';
import { ExitConfirmModal } from '@/components/OnboardingHandlerComponents/ExitConfirmModal';
import { ConfirmModal } from '@/components/OnboardingHandlerComponents/ConfirmModal';
import { siteBuilderAiAnalytics } from '@/analytics/siteBuilderAi';
import { useResize } from '@/hooks/useResize';
import { POPUP_BLOCKED_ORIGIN } from '@/hooks/useBlockedWindowModal/useBlockedWindowModal.enum';
import { SiteBuilderPreview } from '@/components/OnboardingHandlerComponents/SiteBuilderPreview';
import { sentToZenviaOnSuccess } from './sentToZenviaOnSuccess';

let updateStepsTimout = null;
const OnboardingHandler = () => {
  const params = useParams();
  const windowRect = useResize();
  const { width } = windowRect;
  const isMobile = width < 600;
  const [showLogo, setShowLogo] = useState(true);

  const searchParams = new URLSearchParams(window.location.search || '');
  const isIaBuilder = searchParams.get('isIaBuilder') === 'true';

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setShowLogo(scrollPosition < 5);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const withWpMigration = useFeatureIsOn(ATIVACAO_CHOOSE_MIGRATION_STEP);

  const getInitialStep = () => {
    if (isIaBuilder) return STEPS.SITE_BUILDER_V2;
    if (withWpMigration) return STEPS.CHOOSE_WP_MIGRATION;
    return STEPS.CHOOSE_SITE_OPTION;
  };

  const initialStep = getInitialStep();
  const enableTrialGatorProtect = useFeatureIsOn(MONETIZACAO_DISABLE_TRIAL_GATOR_PROTECT);

  const [blockedWindowUrl, setBlockedWindowUrl] = useState('');
  const [sitebuilderLoading, setSitebuilderLoading] = useState(false);
  const [loadingCpanelSSOProduct, setLoadingCpanelSSOProduct] = useState(null);
  const [selectedObject, setSelectedObject] = useState(null);
  const [needRequestChangeDomain, setNeedRequestChangeDomain] = useState({ bool: false });
  const [handlingDomainAvailability, setHandlingDomainAvailability] = useState(false);
  const [selectedOtherOption, setSelectedOtherOption] = useState(null);
  const [displayNormalModeModal, setDisplayNormalModeModal] = useState(false);
  const [displayAdvancedModeModal, setDisplayAdvancedModeModal] = useState(false);
  const [projectData, setProjectData] = useState(null);
  const [typeProject, setTypeProject] = useState(null);
  const [sentToZenvia, setsentToZenvia] = useState(false);
  const [monarxAlreadyActivated, setMonarxAlreadyActivated] = useState(false);

  const sitesReducer = useSelector(state => state.sites);
  const domainsReducer = useSelector(state => state.newDomains);
  const { changeDomain } = useSelector(state => state.newDomains);
  const { onboarding } = useSelector(state => state.summary);
  const { plans: gatorProtectPlans } = useSelector(state => state.gatorProtect);
  const { startOnboarding, sitebuilder: onboardingBuilderState } = useSelector(state => state.newOnboarding);
  const { wordpressLoading, sitebuilder: aiBuilderState } = useSelector(state => state.sites);
  const {
    email: userEmail,
    name: userName,
    country: userCountry,
    features,
  } = useSelector(state => state.summary);
  const { byId: hostings } = useSelector(state => state.generalProducts);
  const { projectUid, loading: createPreviewLoading, status: createPreviewStatus } = useSelector(state => state.sites.sitebuilder.createPreview);

  const history = useHistory();
  const dispatch = useDispatch();
  const { renderBlockedWindowModal, setPopupBlockedModalOnCookie } = useBlockedWindowModal();
  const {
    onboarding: onboardingLocale,
    routes: routesLocale,
    changeDomain: changeDomainLocale,
  } = useLocale();

  const sitesOnboardingEnabled = useFeatureIsOn(ATIVACAO_SITES_ONBOARDING);
  const allowTempDomainCreation = useFeatureIsOn(ATIVACAO_ALLOW_CHOOSE_TEMP_OWNED_DOMAIN_ENTRADA);
  const updateFlowEveryStepChange = useFeatureIsOn(ATIVACAO_UPDATE_ONBOARDING_FLOW_EVERY_STEP_CHANGE);
  const onboardingHgBuilderPreview = useFeatureIsOn(PORTFOLIO_ONBOARDING_HG_BUILDER_PREVIEW);
  const flowCreateSiteTemporaryDomain = useFeatureIsOn(ATIVACAO_TRIGGER_GATE_CREATE_SITE_TEMPORARY_DOMAIN);

  const {
    requestData,
    getAddons,
    cleanUp,
    requestDomainsPage,
    shouldRequestNewDomainsPage,
    getDomainsNextPage,
    resetAddDomainToPlan,
    showAutoCompleteDomain,
    setShowAutoCompleteDomain,
    requestChangeDomain,
    shouldUseCreateTempDomainAsDefault,
    usingTempDomain,
    setUsingTempDomain,
    currentFlow,
    setCurrentFlow,
    isWordPressAI,
    addDomainToPlan,
    currentHosting,
    setCurrentHosting,
    configureDns,
    isInternalDomain,
    otherToolsRedirect,
    setOtherToolsRedirect,
    userDomainsList,
    setDefaultDomains,
    wordpressInstallationIsFinished,
    autoCompleteDomain,
    autoCompleteOptions,
    handleVerifyIfSiteExist,
    checkDomainAvailabilty,
    currentStep,
    setCurrentStep,
    selectedDomain,
    setSelectedDomain,
    onCloseWizard,
    displayExitConfirmModal,
    setDisplayExitConfirmModal,
    provisioningSitebuilderOnHosting,
    requestCreateSiteWithAiBuilder,
    requestCreatePreviewWithAiBuilder,
    requestSyncPreviewWithAiBuilder,
    getBuilderTemplateCategories,
    getBuilderTemplates,
    getBuilderAddonIdByHostingId,
    redirectSuccessPageAiBuilder,
    redirectPreviewPage,
    dispatchClmEvent,
    triggerSiteCreatedWithTempDomain,
    getMonarx,
  } = useOnboardingActions({
    allowTempDomainCreation,
    currentHostingInitialState: onboarding.sites[0],
    initialStep,
    domain: params && params.domain,
    enableTrialGatorProtect,
  });

  const initialStepStyle = currentStep === STEPS.CHOOSE_SITE_OPTION;

  const isLoading = (sitesReducer.loading || domainsReducer.loading || usingTempDomain === undefined)
    && currentStep === initialStep;

  const initialStepGaTag = useCallback(() => {
    onboardingAnalytics.initialStep.accessOnboarding();
  }, []);

  const onComponentMount = useCallback(() => {
    if (features.gator_protect) {
      dispatch(gatorProtectActions.plans.request());
    }
  }, [dispatch, features.gator_protect]);

  useEffect(() => {
    initialStepGaTag();
  }, [initialStepGaTag]);

  useEffect(() => {
    onComponentMount();
  }, [onComponentMount]);

  const chooseDomainStep = STEPS.SELECT_DOMAIN;

  const closeOnboarding = useCallback(() => {
    const surveyUrlBR = 'https://surveys.hotjar.com/a89c27c3-0a5f-44c0-80a9-4a632dfd0c4d';
    const surveyUrlES = 'https://surveys.hotjar.com/ddc6aeac-4e83-4f79-86c0-3f31ebfe960b';
    window.open(isBRServer ? surveyUrlBR : surveyUrlES, '_blank');
    history.push(routesLocale.home);
    sessionStorage.setItem('onboardingFinished', true);
    dispatch(onboardingActions.onboarding.register.request({
      hostingId: currentHosting && currentHosting.hosting_id,
      domain: currentHosting && currentHosting.domain,
      origin: 'onboarding',
      skip: true,
    }));
  }, [currentHosting, history, routesLocale, dispatch]);

  const handleGoBack = useCallback(() => {
    const analyticsRules = {
      [FLOWS.WORDPRESS_IA]: onboardingAnalytics.wordpressIa.goBackStep1,
      [FLOWS.WORDPRESS]: onboardingAnalytics.wordpressDefault.goBackStep1,
      [FLOWS.SITE_BUILDER]: onboardingAnalytics.sitebuilder.goBackStep1,
      [FLOWS.OTHER_TOOLS]: onboardingAnalytics.otherTools.goBackStep1,
    };
    const analyticGoBackCta = analyticsRules[currentFlow];
    if (analyticGoBackCta) {
      analyticGoBackCta();
    }

    if (currentStep === STEPS.CHOOSE_WP_MIGRATION) {
      closeOnboarding();
      return;
    }

    if (currentFlow === FLOWS.WORDPRESS_MIGRATION || withWpMigration) {
      setCurrentStep(STEPS.CHOOSE_WP_MIGRATION);
      shouldUseCreateTempDomainAsDefault();
      return;
    }

    closeOnboarding();
  }, [
    currentFlow,
    currentStep,
    setCurrentStep,
    withWpMigration,
    shouldUseCreateTempDomainAsDefault,
    closeOnboarding,
  ]);

  useEffect(() => {
    shouldUseCreateTempDomainAsDefault();
  }, [shouldUseCreateTempDomainAsDefault]);

  useEffect(() => {
    requestData();
  }, [requestData]);

  useEffect(() => {
    if (currentFlow === FLOWS.SITE_BUILDER) {
      getAddons({ currentHosting });
    }
  }, [getAddons, currentHosting, currentFlow]);

  useEffect(() => {
    requestDomainsPage();
  }, [requestDomainsPage]);

  useEffect(() => {
    shouldRequestNewDomainsPage();
  }, [shouldRequestNewDomainsPage]);

  const nextStepRule = useMemo(() => {
    const displaySuccessOnSitebuilder = isInternalDomain || (needRequestChangeDomain && needRequestChangeDomain.newDomain && domainsReducer.list && domainsReducer.list.find(item => item.domain === needRequestChangeDomain.newDomain));

    return {
      [FLOWS.WORDPRESS]: STEPS.WORDPRESS_INSTALL,
      [FLOWS.WORDPRESS_IA]: STEPS.WORDPRESS_INSTALL,
      [FLOWS.SITE_BUILDER]: displaySuccessOnSitebuilder ? STEPS.SUCCESS : STEPS.EXTERNAL_DOMAIN,
      [FLOWS.SITE_BUILDER_V2]: STEPS.SITE_BUILDER_V2,
      [FLOWS.OTHER_TOOLS]: STEPS.SUCCESS,
      [FLOWS.AGENT_FACTORY]: STEPS.SUCCESS,
      [FLOWS.WORDPRESS_MIGRATION]: STEPS.WORDPRESS_MIGRATION,
    };
  }, [isInternalDomain, domainsReducer.list, needRequestChangeDomain]);

  const dispatchUpdateStepperDefaultFlow = useCallback(({ forced, finished, createdTempDomain }) => {
    if ((domainsReducer.changeDomain.loading || needRequestChangeDomain.bool) && !forced) {
      return;
    }

    if (updateFlowEveryStepChange && (startOnboarding || forced)) {
      const stepAsKebabCase = currentStep.replace(/_/g, '-').toLowerCase();

      const builderRules = {
        [FLOWS.WORDPRESS]: 'wordpress',
        [FLOWS.WORDPRESS_IA]: 'wordpress-ia',
        [FLOWS.SITE_BUILDER]: 'sitebuilder',
        [FLOWS.SITE_BUILDER_V2]: 'brizy',
        [FLOWS.OTHER_TOOLS]: 'other',
        [FLOWS.WORDPRESS_MIGRATION]: 'wordpress',
      };

      const isFinished = ((currentStep === STEPS.SUCCESS || currentStep === STEPS.EXTERNAL_DOMAIN) && currentFlow !== FLOWS.OTHER_TOOLS)
        || finished;

      if ((isFinished)) {
        sessionStorage.setItem('onboardingFinished', true);
      }

      const builder = (currentFlow === FLOWS.OTHER_TOOLS && selectedOtherOption)
        ? `${builderRules[currentFlow]}-${selectedOtherOption}`
        : builderRules[currentFlow];

      if (currentFlow !== FLOWS.WORDPRESS_MIGRATION && !!builder) {
        dispatch(onboardingActions.onboarding.update.request({
          hostingId: currentHosting && currentHosting.hosting_id,
          domain: createdTempDomain || (currentHosting && currentHosting.domain),
          origin: 'onboarding',
          builder,
          step: stepAsKebabCase,
          finished: !!isFinished,
        }));
      }
    }
  }, [
    currentFlow,
    currentHosting,
    dispatch,
    startOnboarding,
    currentStep,
    updateFlowEveryStepChange,
    selectedOtherOption,
    domainsReducer.changeDomain,
    needRequestChangeDomain,
  ]);

  const continueAfterCreatingTempDomain = useCallback(() => {
    if (
      usingTempDomain
      && domainsReducer.createdTemporaryDomain
      && !domainsReducer.loadingTemporaryDomainCreation
      && [STEPS.SELECT_DOMAIN, STEPS.BUY_DOMAIN].includes(currentStep)
      && !sitesReducer.loading
    ) {
      setCurrentHosting({
        ...currentHosting,
        domain: domainsReducer.createdTemporaryDomain,
      });

      if (needRequestChangeDomain.bool) {
        requestChangeDomain({
          newDomain: domainsReducer.createdTemporaryDomain,
          hostingId: currentHosting.hosting_id,
          fallback: () => {
            setNeedRequestChangeDomain({
              ...needRequestChangeDomain,
              bool: false,
            });
            dispatchUpdateStepperDefaultFlow({ forced: true, createdTempDomain: domainsReducer.createdTemporaryDomain });
          },
        });
      } else {
        addDomainToPlan({
          domain: domainsReducer.createdTemporaryDomain,
          hostingId: currentHosting.hosting_id,
          selectedObject: currentHosting,
        });
      }


      dispatch(domainsActions.temporaryDomains.creation.set(null));
    }
  }, [
    domainsReducer.createdTemporaryDomain,
    domainsReducer.loadingTemporaryDomainCreation,
    currentHosting,
    dispatch,
    addDomainToPlan,
    sitesReducer.loading,
    currentStep,
    usingTempDomain,
    setCurrentHosting,
    needRequestChangeDomain,
    requestChangeDomain,
    dispatchUpdateStepperDefaultFlow,
  ]);

  const updateToNextStep = useCallback(() => {
    if (
      usingTempDomain
      && sitesReducer.domainLinkedToPlan
      && [
        STEPS.SELECT_DOMAIN,
        STEPS.SELECT_PLAN_LIST,
        STEPS.BUY_DOMAIN,
      ].includes(currentStep)
    ) {
      setCurrentStep(nextStepRule[currentFlow]);
      resetAddDomainToPlan({ domainLinkedToPlan: false });
    }
  }, [
    currentFlow,
    nextStepRule,
    currentStep,
    sitesReducer.domainLinkedToPlan,
    resetAddDomainToPlan,
    usingTempDomain,
    setCurrentStep,
  ]);

  useEffect(() => {
    updateToNextStep();
  }, [updateToNextStep]);

  useEffect(() => {
    continueAfterCreatingTempDomain();
  }, [continueAfterCreatingTempDomain]);

  const resetStatusOnLeave = useCallback(() => {
    cleanUp();
  }, [cleanUp]);

  useEffect(() => () => {
    resetStatusOnLeave();
  }, [resetStatusOnLeave]);

  const noFilesToBeExcluded = !sitesReducer.currentlyInstallInfo.siteId
    && !sitesReducer.needToExcludeDefaultFiles
    && sitesReducer.siteExistVerifyFinished;

  const readyToCreateSite = (noFilesToBeExcluded && !sitesReducer.loadingUninstall) || sitesReducer.uninstallCompleted;

  const redirectToSiteAlreadyCreatedStep = useCallback(() => {
    if (sitesReducer.needToExcludeDefaultFiles && !sitesReducer.uninstallCompleted && !sitesReducer.loadingUninstall && selectedObject) {
      return dispatch(sitesActions.uninstallSite.request({
        domain: currentHosting.domain,
        hostingId: currentHosting.hosting_id,
        domainId: selectedObject && selectedObject.id,
        domainHasPlan: true,
        needToExcludeDefaultFiles: true,
      }));
    }

    if (readyToCreateSite) {
      dispatch(sitesActions.verifyIfSiteExist.reset());
      return setCurrentStep(nextStepRule[currentFlow]);
    }
  }, [
    currentHosting,
    selectedObject,
    currentFlow,
    nextStepRule,
    sitesReducer.needToExcludeDefaultFiles,
    sitesReducer.uninstallCompleted,
    sitesReducer.loadingUninstall,
    readyToCreateSite,
    dispatch,
    setCurrentStep,
  ]);

  useEffect(() => {
    redirectToSiteAlreadyCreatedStep();
  }, [
    redirectToSiteAlreadyCreatedStep,
  ]);

  const onSuccessChangeDomain = useCallback(() => {
    const changeDomainHasSuccess = changeDomain.lastAttempt === 'success';
    const isInChangeDomainStep = currentStep === STEPS.SELECT_DOMAIN;

    if (changeDomainHasSuccess && changeDomain.newDomain) {
      setCurrentHosting({
        ...currentHosting,
        domain: changeDomain.newDomain,
      });
    }

    if (isInChangeDomainStep && changeDomainHasSuccess) {
      setCurrentStep(nextStepRule[currentFlow]);
    }
  }, [
    nextStepRule,
    changeDomain.lastAttempt,
    changeDomain.newDomain,
    currentHosting,
    currentStep,
    currentFlow,
    setCurrentHosting,
    setCurrentStep,
  ]);

  useEffect(() => {
    onSuccessChangeDomain();
  }, [onSuccessChangeDomain]);

  useEffect(() => {
    getDomainsNextPage();
  }, [getDomainsNextPage]);

  useEffect(() => {
    setDefaultDomains({
      setSelectedDomain,
      paramsDomain: params.domain,
    });
  }, [setDefaultDomains, setSelectedDomain, params]);

  const updateOnboardingSteps = useCallback(({ forced, finished }) => {
    if (forced) {
      dispatchUpdateStepperDefaultFlow({ forced, finished });
    }

    if (!forced) {
      clearTimeout(updateStepsTimout);
      updateStepsTimout = setTimeout(() => {
        dispatchUpdateStepperDefaultFlow({ forced, finished });
      }, 100);
    }
  }, [
    dispatchUpdateStepperDefaultFlow,
  ]);

  const handleRegisterHostingOnboarding = useCallback(() => {
    const origin = 'onboarding';
    const canRequestRegister = currentHosting.hosting_id;
    const startRegister = startOnboarding;

    if (!startRegister && canRequestRegister) {
      const builderInfo = {
        domain: currentHosting && currentHosting.domain,
        origin,
        hostingId: currentHosting.hosting_id,
      };

      dispatch(onboardingActions[origin].register.request(builderInfo));
    }
  }, [
    currentHosting,
    startOnboarding,
    dispatch,
  ]);

  const getChooseSiteOptionProps = useCallback(() => {
    const options = [
      {
        ...onboardingLocale.chooseSiteOption.options[0],
        cta: {
          ...onboardingLocale.chooseSiteOption.options[0].cta,
          action: () => {
            handleRegisterHostingOnboarding();
            setCurrentFlow(FLOWS.SITE_BUILDER_V2);
            onboardingAnalytics.initialStep.accessSitebuilderV2();
            onboardingAnalytics.sitebuilder.select();
            setCurrentStep(STEPS.SELECT_DOMAIN);
          },
        },
      },
      {
        ...onboardingLocale.chooseSiteOption.options[1],
        cta: {
          ...onboardingLocale.chooseSiteOption.options[1].cta,
          action: () => {
            handleRegisterHostingOnboarding();
            setCurrentFlow(FLOWS.WORDPRESS_IA);
            onboardingAnalytics.initialStep.accessWordpressIA();
            setCurrentStep(STEPS.SELECT_DOMAIN);
            onboardingAnalytics.wordpressIa.select();
          },
        },
        ctaFooter: {
          ...onboardingLocale.chooseSiteOption.options[1].ctaFooter,
          action: () => setDisplayNormalModeModal(true),
        },
      },
    ];

    return {
      title: onboardingLocale.chooseSiteOption.title,
      options,
      haveExperienceLabel: onboardingLocale.chooseSiteOption.haveExperienceLabel,
      ctaAdvancedMode: {
        ...onboardingLocale.chooseSiteOption.ctaAdvancedMode,
        action: () => {
          setDisplayAdvancedModeModal(true);
          onboardingAnalytics.otherTools.select();
        },
      },
    };
  }, [
    onboardingLocale,
    setCurrentStep,
    setCurrentFlow,
    setDisplayAdvancedModeModal,
    handleRegisterHostingOnboarding,
  ]);

  useEffect(() => {
    updateOnboardingSteps({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentStep, currentHosting, startOnboarding, selectedOtherOption]);

  useEffect(() => {
    const domain = currentHosting ? currentHosting.domain : selectedObject.domain;
    wordpressInstallationIsFinished({ domain });
  }, [wordpressInstallationIsFinished, setCurrentStep, currentStep, currentHosting, selectedObject]);

  const handleCloseBlockedWindowModal = () => {
    setBlockedWindowUrl('');
  };

  const redirectToPortal = useCallback(() => {
    dispatch(clearOnboarding());

    history.push(routesLocale.home);
  }, [dispatch, history, routesLocale]);

  const handleCloseOnBoarding = useCallback(() => {
    const hgBuilderSteps = [STEPS.IA_BUILDER_CREATE_SITE, STEPS.IA_BUILDER_WITH_TEMPLATE, STEPS.IA_BUILDER_MY_BUSINESS];

    if (hgBuilderSteps.includes(currentStep)) {
      setDisplayExitConfirmModal(true);
      return;
    }

    closeOnboarding();
    dispatch(clearOnboarding());
  }, [currentStep, setDisplayExitConfirmModal, dispatch, closeOnboarding]);


  useEffect(() => {
    handleVerifyIfSiteExist();
  }, [handleVerifyIfSiteExist]);

  const handleCreateTempDomain = useCallback(({ hostingId }) => {
    if (!hostingId) {
      const userMultiDomainsPlans = userDomainsList.filter(item => multiDomainsPlansIds.includes(item.package_id) && item.product_name);
      if (userMultiDomainsPlans.length > 1) {
        setCurrentStep(STEPS.SELECT_PLAN_LIST);
        return;
      }

      if (userMultiDomainsPlans.length === 1) {
        const availablePlan = userMultiDomainsPlans[0];
        delete availablePlan.domain;
        setCurrentHosting({
          ...availablePlan,
          hosting_id: availablePlan.hosting_id,
        });

        dispatch(domainsActions.temporaryDomains.creation.request({ hostingId: availablePlan.hosting_id }));
        return;
      }
    }

    if (hostingId) {
      setNeedRequestChangeDomain({
        bool: true,
      });
      dispatch(domainsActions.temporaryDomains.creation.request({ hostingId }));
    }
  }, [
    dispatch,
    userDomainsList,
    setCurrentHosting,
    setCurrentStep,
  ]);

  const handleDomainAvailability = useCallback(() => {
    if (
      sitesReducer.domainAvailability !== undefined
      && !sitesReducer.loading
      && !sitesReducer.loadingDomainValidation
      && ((selectedObject
        && selectedObject.selectedDomain) || needRequestChangeDomain.newDomain)
      && currentStep === STEPS.SELECT_DOMAIN
      && !handlingDomainAvailability
    ) {
      setHandlingDomainAvailability(true);
      const domain = (selectedObject && selectedObject.selectedDomain) || (needRequestChangeDomain.newDomain);
      const domainIsAvailable = sitesReducer.domainAvailability === true;

      if ((domain) && !domainIsAvailable) {
        if (needRequestChangeDomain.bool && needRequestChangeDomain.newDomain) {
          requestChangeDomain({
            newDomain: needRequestChangeDomain.newDomain,
            hostingId: currentHosting.hosting_id,
          });
          setNeedRequestChangeDomain({
            ...needRequestChangeDomain,
            bool: false,
          });
        }

        if (!needRequestChangeDomain.bool) {
          dispatch(sitesActions.verifyIfSiteExist.reset());
          const isNewTypedDomain = !selectedObject.hosting_id;

          setCurrentHosting({
            ...currentHosting,
            domain: selectedObject.selectedDomain,
          });

          if (usingTempDomain) {
            handleCreateTempDomain({ hostingId: selectedObject.hosting_id });
          }

          if (!usingTempDomain) {
            if (!isNewTypedDomain) {
              configureDns({
                domain: selectedObject.selectedDomain,
                domainId: selectedObject.domain_id,
                hostingId: currentHosting.hosting_id,
              });
            }
            dispatch(sitesActions.verifyIfSiteExist.request({
              domain: selectedObject.domain || domainsReducer.createdTemporaryDomain,
              hostingId: currentHosting.hosting_id,
            }));
          }
        }
      }

      if (domain && domainIsAvailable && !usingTempDomain) {
        setCurrentStep(STEPS.BUY_DOMAIN);
      }
    }
  }, [
    sitesReducer.domainAvailability,
    selectedObject,
    dispatch,
    currentHosting,
    sitesReducer.loadingDomainValidation,
    usingTempDomain,
    handleCreateTempDomain,
    sitesReducer.loading,
    needRequestChangeDomain,
    requestChangeDomain,
    currentStep,
    handlingDomainAvailability,
    setHandlingDomainAvailability,
    setCurrentHosting,
    configureDns,
    setCurrentStep,
    domainsReducer,
  ]);

  useEffect(() => {
    handleDomainAvailability();
  }, [handleDomainAvailability]);

  const getChooseDomainProps = useCallback(() => {
    if ((!currentHosting || !currentHosting.domain)) return;

    const changeDomainLoading = changeDomain.loading;

    const backToInitialStep = () => {
      const analyticsRules = {
        [FLOWS.WORDPRESS_IA]: onboardingAnalytics.wordpressIa.goBackStep1,
        [FLOWS.WORDPRESS]: onboardingAnalytics.wordpressDefault.goBackStep1,
        [FLOWS.SITE_BUILDER]: onboardingAnalytics.sitebuilder.goBackStep1,
        [FLOWS.OTHER_TOOLS]: onboardingAnalytics.otherTools.goBackStep1,
      };

      const analyticGoBackCta = analyticsRules[currentFlow];
      analyticGoBackCta && analyticGoBackCta();

      setCurrentStep(STEPS.CHOOSE_SITE_OPTION);
      shouldUseCreateTempDomainAsDefault();
    };

    const backToChooseWpMigration = () => {
      setCurrentStep(STEPS.CHOOSE_WP_MIGRATION);
      shouldUseCreateTempDomainAsDefault();
    };

    const handleContinue = ({ newDomain, needRequestChangeDomain }) => {
      setHandlingDomainAvailability(false);
      onboardingAnalytics.chooseDomain.selectDomainContinue();

      const analyticsRules = {
        [FLOWS.WORDPRESS_IA]: onboardingAnalytics.wordpressIa.goForwardStep1,
        [FLOWS.WORDPRESS]: onboardingAnalytics.wordpressDefault.goForwardStep1,
        [FLOWS.SITE_BUILDER]: onboardingAnalytics.sitebuilder.goForwardStep1,
        [FLOWS.OTHER_TOOLS]: onboardingAnalytics.otherTools.goForwardStep1,
      };

      const analyticGoForwardCta = analyticsRules[currentFlow];
      analyticGoForwardCta && analyticGoForwardCta();

      if (usingTempDomain) {
        const currentDomainIsTempAlready = currentHosting.domain.includes('myhostgator.site');
        if (currentDomainIsTempAlready) {
          setCurrentStep(nextStepRule[currentFlow]);
        }

        if (!currentDomainIsTempAlready) {
          handleCreateTempDomain({ hostingId: currentHosting.hosting_id });
        }
      }

      if (!usingTempDomain) {
        setNeedRequestChangeDomain({
          bool: needRequestChangeDomain,
          newDomain,
        });
        checkDomainAvailabilty({ domain: newDomain });
      }
    };

    const hasMultDomainPlans = !!sitesReducer.list.filter(item => multiDomainsPlansIds.includes(item.package_id) && item.product_name && item.status === 'Active').length;

    const handleToggleTempDomain = () => {
      setUsingTempDomain(!usingTempDomain);
    };

    const buttonsProps = {
      leftButton: {
        id: 'choose-domain-left-button',
        testId: 'choose-domain-left-button',
        label: onboardingLocale.goBackButtonLabel,
        onClick: currentFlow === FLOWS.WORDPRESS_MIGRATION ? backToChooseWpMigration : backToInitialStep,
      },
      rightButton: [
        {
          id: 'toggle-temp-domain-button',
          testId: 'toggleTempDomain',
          variant: 'tertiary',
          label: usingTempDomain ? onboardingLocale.useOwnedDomain : onboardingLocale.useTempDomain,
          onClick: handleToggleTempDomain,
        },
        {
          id: 'choose-domain-right-button',
          testId: 'choose-domain-right-button',
          label: onboardingLocale.continueButtonLabel,
          iconRight: !changeDomainLoading && <IconArrow direction="right" />,
          onClick: handleContinue,
        },
      ],
    };

    return {
      locales: onboardingLocale.domainRegistered,
      domainMessageErrorBr: changeDomainLocale.steps.inputDomain.domainMessageErrorBr,
      domainMessageError: changeDomainLocale.steps.inputDomain.domainMessageError,
      currentFlow,
      changeDomainLoading,
      buttonsProps,
      showAutoCompleteDomain,
      autoCompleteOptions,
      autoCompleteDomain,
      setShowAutoCompleteDomain,
      userDomainsList,
      selectedDomain,
      setSelectedDomain,
      resetAddDomainToPlan,
      loadingSites: sitesReducer.loading,
      loadingVerifyIfSiteExist: sitesReducer.loadingVerifyIfSiteExist,
      loadingUninstall: sitesReducer.loadingUninstall,
      loadingDomainValidation: sitesReducer.loadingDomainValidation,
      usingTempDomain,
      loadingTempDomainCreation: domainsReducer.loadingTempDomainCreation,
      allowTempDomainCreation,
      hasMultDomainPlans,
      FLOWS,
      insideWizard: false,
    };
  }, [
    onboardingLocale,
    currentHosting,
    resetAddDomainToPlan,
    changeDomain.loading,
    showAutoCompleteDomain,
    autoCompleteOptions,
    autoCompleteDomain,
    changeDomainLocale,
    userDomainsList,
    selectedDomain,
    sitesReducer.loading,
    sitesReducer.loadingVerifyIfSiteExist,
    sitesReducer.loadingUninstall,
    currentFlow,
    checkDomainAvailabilty,
    sitesReducer.loadingDomainValidation,
    usingTempDomain,
    domainsReducer.loadingTempDomainCreation,
    allowTempDomainCreation,
    nextStepRule,
    setShowAutoCompleteDomain,
    setUsingTempDomain,
    shouldUseCreateTempDomainAsDefault,
    setCurrentStep,
    setSelectedDomain,
    handleCreateTempDomain,
    sitesReducer.list,
  ]);

  const getWordPressInstallProps = useCallback(() => {
    const shouldUseTempDomainCreation = !!(
      allowTempDomainCreation
      && !!sitesReducer.list.filter(item => multiDomainsPlansIds.includes(item.package_id) && item.product_name).length
      && currentFlow !== FLOWS.SITE_BUILDER
    );

    const onSubmit = ({ admin, password }) => {
      const analyticsRules = {
        [FLOWS.WORDPRESS_IA]: onboardingAnalytics.wordpressIa.goForwardStep2,
        [FLOWS.WORDPRESS]: onboardingAnalytics.wordpressDefault.goForwardStep2,
      };

      const goForwardCta = analyticsRules[currentFlow];
      goForwardCta && goForwardCta();

      const wordpress = {
        domain: (currentHosting && currentHosting.domain) || (domainsReducer.createdTemporaryDomain),
        admin: DOMPurify.sanitize(admin),
        password: DOMPurify.sanitize(password),
        email: userEmail,
        name: userName,
        description: '',
        sets: isWordPressAI ? [`Extendify-${COUNTRY}_admin`] : [],
        external_id: currentHosting.hosting_id,
      };

      dispatch(sitesActions.wordpressInstallation.request({
        wordpress,
        isWondersuiteEnabled: true,
        themeId: 'wp-default',
        userSelectedWondersuiteTrial: false,
        isFastCheckoutAddonEnabled: true,
        userSelectedUseEcommercePlus: false,
      }));
    };

    const leftButtonClick = () => {
      dispatch(sitesActions.verifyIfSiteExist.reset());
      const analyticsRules = {
        [FLOWS.WORDPRESS_IA]: onboardingAnalytics.wordpressIa.goBackStep2,
        [FLOWS.WORDPRESS]: onboardingAnalytics.wordpressDefault.goBackStep2,
      };

      const goBackCta = analyticsRules[currentFlow];
      goBackCta && goBackCta();

      const previousStep = shouldUseTempDomainCreation ? chooseDomainStep : STEPS.CHOOSE_SITE_OPTION;

      setCurrentStep(previousStep);
    };

    const buttonsProps = {
      leftButton: {
        label: onboardingLocale.goBackButtonLabel,
        onClick: leftButtonClick,
        disabled: wordpressLoading,
      },
      rightButton: {
        label: onboardingLocale.continueButtonLabel,
        iconRight: !wordpressLoading && <IconArrow direction="right" />,
      },
    };

    return {
      locales: onboardingLocale.wordPress,
      buttonsProps,
      isWordPressAI,
      currentFlow,
      wordpressLoading,
      onSubmit,
      FLOWS,
      linkingDomain: sitesReducer.loading,
    };
  }, [
    domainsReducer.createdTemporaryDomain,
    currentFlow,
    onboardingLocale,
    isWordPressAI,
    userEmail,
    userName,
    wordpressLoading,
    currentHosting,
    chooseDomainStep,
    dispatch,
    allowTempDomainCreation,
    sitesReducer,
    setCurrentStep,
  ]);

  const getSuccessOtherToolsProps = useCallback(() => {
    const redirectToCpanel = ({ softaculous }) => {
      updateOnboardingSteps({ forced: true, finished: true });

      onboardingAnalytics.otherTools.startNow();

      setLoadingCpanelSSOProduct(true);

      const cpanelUrl = getURLCpanel({
        externalId: currentHosting.hosting_id,
        dispatch,
        setLoadingCpanelSSOProduct: setLoadingCpanelSSOProduct(true),
        setBlockedWindowUrl,
        redirect: redirectToPortal,
      });

      const params = softaculous ? '&app=Softaculous_Home' : '';
      const url = `${cpanelUrl}${params}`;
      window.open(url, '_blank');

      redirectToPortal();
    };

    const redirectToFtp = () => {
      updateOnboardingSteps({ forced: true, finished: true });

      onboardingAnalytics.otherTools.startNow();

      setLoadingCpanelSSOProduct(true);
      dispatch(removeProductDetail());
      history.push(`${routesLocale.products}${routesLocale.productdetail}/${currentHosting.hosting_id}`);

      dispatch(clearOnboarding());
    };

    const handleRedirectToPortal = () => {
      updateOnboardingSteps({ forced: true, finished: true });


      onboardingAnalytics.otherTools.portalButton();

      redirectToPortal();
    };

    const redirectToDomainFeedback = ({ redirectFunc }) => {
      setOtherToolsRedirect(() => redirectFunc);

      if (!isInternalDomain) {
        return setCurrentStep(STEPS.EXTERNAL_DOMAIN);
      }

      if (sitesReducer.domainDnsChanged) {
        return setCurrentStep(STEPS.SUCCESS);
      }
    };

    const onBackToStart = () => {
      setCurrentStep(STEPS.CHOOSE_SITE_OPTION);
    };

    return ({
      title: onboardingLocale.otherTools.title,
      description: onboardingLocale.otherTools.description,
      options: onboardingLocale.otherTools.options,
      redirectToCpanel,
      loadingCpanelSSOProduct,
      redirectToFtp,
      rightButtonLabel: onboardingLocale.otherTools.rightButtonLabel,
      goToPortalButtonLabel: onboardingLocale.otherTools.goToPortalButtonLabel,
      leftButtonLabel: onboardingLocale.otherTools.leftButtonLabel,
      handleRedirectToPortal,
      onBackToStart,
      redirectToDomainFeedback,
      dnsChanged: sitesReducer.domainDnsChanged,
      cleanUp,
      isInternalDomain,
      usingTempDomain,
      setSelectedOtherOption,
    });
  }, [
    usingTempDomain,
    sitesReducer.domainDnsChanged,
    isInternalDomain,
    currentHosting,
    dispatch,
    redirectToPortal,
    setBlockedWindowUrl,
    setLoadingCpanelSSOProduct,
    loadingCpanelSSOProduct,
    history,
    routesLocale,
    onboardingLocale,
    cleanUp,
    setOtherToolsRedirect,
    setCurrentStep,
    updateOnboardingSteps,
  ]);

  const siteBuilderSso = useCallback(() => {
    setSitebuilderLoading(true);
    dispatch(clearOnboarding()).then(() => {
      const url = `${routesLocale.siteBuilderRedirectAccess}/${currentHosting.domain}/${currentHosting.hosting_id}`;

      window.open(url, '_blank');
      history.push(routesLocale.home);
    });
  }, [
    dispatch,
    currentHosting.domain,
    currentHosting.hosting_id,
    history,
    routesLocale,
  ]);

  const getGenericSuccessProps = useCallback(() => {
    const wordpressSso = () => {
      if (sitesReducer.wordpressSso.ssoUrl) {
        window.open(sitesReducer.wordpressSso.ssoUrl, '_blank');
        redirectToPortal();
        return;
      }

      dispatch(sitesActions.wordpressSso.request({
        hostingId: currentHosting.hosting_id,
        domain: currentHosting.domain,
        siteId: sitesReducer.wordpressSso.siteId,
        callbackFunction: redirectToPortal,
      }));
    };

    const getLocale = () => {
      if (sitesReducer.domainDnsChanged) {
        return onboardingLocale.configuredDnsSuccess;
      }

      const rules = {
        [FLOWS.WORDPRESS]: onboardingLocale.wordPress.wpNormalSuccess(usingTempDomain),
        [FLOWS.WORDPRESS_IA]: onboardingLocale.wordPress.wpIaSuccess(usingTempDomain),
        [FLOWS.SITE_BUILDER]: onboardingLocale.domainRegistered.success,
        [FLOWS.OTHER_TOOLS]: onboardingLocale.otherTools.success,
      };

      return rules[currentFlow];
    };

    const getImage = () => {
      const rules = {
        [FLOWS.WORDPRESS]: WpNormalScreen,
        [FLOWS.WORDPRESS_IA]: WpIaScreen,
        [FLOWS.SITE_BUILDER]: isBRServer ? siteBuilderSuccessBr : siteBuilderSuccessEs,
        [FLOWS.OTHER_TOOLS]: OtherToolsScreen,
      };

      return rules[currentFlow];
    };

    const getRightButtonAction = () => {
      const rules = {
        [FLOWS.WORDPRESS]: () => {
          wordpressSso();
          onboardingAnalytics.wordpressDefault.startNow();
          onboardingAnalytics.wordpressDefault.successContinue();
        },
        [FLOWS.WORDPRESS_IA]: () => {
          wordpressSso();
          onboardingAnalytics.wordpressIa.startNow();
          onboardingAnalytics.wordpressDefault.successContinue();
        },
        [FLOWS.SITE_BUILDER_V2]: () => { setCurrentStep(STEPS.SITE_BUILDER_V2); },
        [FLOWS.SITE_BUILDER]: () => { siteBuilderSso(); onboardingAnalytics.sitebuilder.startNow(); },
        [FLOWS.OTHER_TOOLS]: () => otherToolsRedirect(),
      };

      return rules[currentFlow];
    };

    const getRightButtonLoading = () => {
      const rules = {
        [FLOWS.WORDPRESS]: sitesReducer.wordpressSso.loading,
        [FLOWS.WORDPRESS_IA]: sitesReducer.wordpressSso.loading,
        [FLOWS.SITE_BUILDER]: sitebuilderLoading,
      };

      return rules[currentFlow];
    };

    const getRightButtonDisabled = () => {
      const rules = {
        [FLOWS.WORDPRESS]: sitesReducer.wordpressSso.loading,
        [FLOWS.WORDPRESS_IA]: sitesReducer.wordpressSso.loading,
        [FLOWS.SITE_BUILDER]: sitebuilderLoading,
      };

      return rules[currentFlow];
    };

    const testIdRules = {
      [FLOWS.WORDPRESS]: 'wp-normal',
      [FLOWS.WORDPRESS_IA]: 'wp-ai',
      [FLOWS.SITE_BUILDER]: 'sitebuilder',
    };

    const handleRedirectToPortal = () => {
      const analyticRules = {
        [FLOWS.WORDPRESS]: onboardingAnalytics.wordpressDefault.portalButton,
        [FLOWS.WORDPRESS_IA]: onboardingAnalytics.wordpressIa.portalButton,
        [FLOWS.SITE_BUILDER]: onboardingAnalytics.sitebuilder.portalButton,
      };

      const portalCta = analyticRules[currentFlow];
      portalCta && portalCta();
      onboardingAnalytics.wordpressDefault.successGoToPortal();

      if (otherToolsRedirect) {
        return otherToolsRedirect();
      }

      redirectToPortal();
    };

    return {
      imageSrc: getImage(),
      locales: getLocale(),
      buttonsProps: {
        leftButton: {
          testId: `${testIdRules[currentFlow]}-success-left-button`,
          label: onboardingLocale.wordPress.leftButtonLabel,
          onClick: handleRedirectToPortal,
        },
        rightButton: {
          testId: `${testIdRules[currentFlow]}-success-right-button`,
          label: onboardingLocale.wordPress.rightButtonLabel,
          iconRight: <IconArrow direction="right" />,
          onClick: getRightButtonAction(),
          loading: getRightButtonLoading(),
          disabled: getRightButtonDisabled(),
        },
      },
      cleanUp,
      blueSubtitle: currentFlow === FLOWS.SITE_BUILDER,
    };
  }, [
    usingTempDomain,
    otherToolsRedirect,
    onboardingLocale,
    sitesReducer.wordpressSso,
    dispatch,
    currentFlow,
    sitebuilderLoading,
    currentHosting,
    redirectToPortal,
    cleanUp,
    sitesReducer.domainDnsChanged,
    setCurrentStep,
    siteBuilderSso,
  ]);

  const getDomainNotRegisteredProps = useCallback(() => {
    const domainInUse = (selectedObject && selectedObject.selectedDomain) || needRequestChangeDomain.newDomain;

    const handleBuyDomain = () => {
      const splitedOtherDomain = domainInUse.split('.');
      window.open(`${CART_URL}?pid=d&sld=${splitedOtherDomain[0]}&tld=.${splitedOtherDomain[1]}`, '_blank').focus();
      redirectToPortal();
    };

    const useTempDomain = () => {
      setUsingTempDomain(true);
      setCurrentStep(nextStepRule[currentFlow]);
    };

    const backToChooseDomain = () => {
      setNeedRequestChangeDomain({ bool: false });
      dispatch(sitesActions.domainAvailability.set({}));
      setSelectedObject(null);
      setCurrentStep(chooseDomainStep);
    };

    const buttonsProps = {
      leftButton: {
        label: onboardingLocale.goBackButtonLabel,
        onClick: backToChooseDomain,
      },
      rightButton: [
        {
          label: onboardingLocale.useTempDomain,
          variant: 'tertiary',
          onClick: useTempDomain,
          disabled: domainsReducer.loadingTempDomainCreation || sitesReducer.loading,
          loading: domainsReducer.loadingTempDomainCreation || sitesReducer.loading,
        },
        {
          label: onboardingLocale.continueButtonLabel,
          iconRight: <IconExternalLink size="sm" color="highPure" secondaryColor="transparent" />,
          notFillSVG: true,
          onClick: handleBuyDomain,
          testId: 'go-to-checkout-button',
        },
      ],
    };

    return {
      locales: onboardingLocale.domainNotRegistered,
      buttonsProps,
      domain: (selectedObject && selectedObject.selectedDomain) || needRequestChangeDomain.newDomain,
      currentFlow,
      FLOWS,
      hasMultDomainPlans: !!sitesReducer.list.filter(item => multiDomainsPlansIds.includes(item.package_id) && item.product_name).length,
    };
  }, [
    onboardingLocale,
    selectedObject,
    chooseDomainStep,
    domainsReducer.loadingTempDomainCreation,
    needRequestChangeDomain.newDomain,
    sitesReducer.loading,
    dispatch,
    redirectToPortal,
    currentFlow,
    nextStepRule,
    setUsingTempDomain,
    setCurrentStep,
    sitesReducer.list,
  ]);

  const getExternalDomainProps = useCallback(() => {
    const goToSites = () => history.push(routesLocale.sites);
    const redirect = otherToolsRedirect || goToSites;

    let buttonsProps = {
      rightButton: {
        label: onboardingLocale.externalDomain.continueButtonLabel,
        iconRight: <IconArrow direction="right" />,
        onClick: redirect,
      },
    };

    const selectedObjectDomain = selectedObject && (selectedObject.domain || selectedObject.selectedDomain);
    const domain = currentHosting.domain || selectedObjectDomain;

    if (currentFlow === FLOWS.SITE_BUILDER) {
      buttonsProps = {
        leftButton: {
          label: onboardingLocale.externalDomain.continueButtonLabel,
          onClick: redirect,
          varian: 'secondary',
        },
        rightButton: {
          label: onboardingLocale.externalDomain.startNow,
          iconRight: <IconArrow direction="right" />,
          onClick: siteBuilderSso,
          disabled: sitebuilderLoading,
          loading: sitebuilderLoading,
        },
      };
    }

    const locales = {
      ...onboardingLocale.externalDomain,
      title: onboardingLocale.externalDomain.title(domain),
    };

    const getImage = () => {
      const rules = {
        [FLOWS.WORDPRESS]: WpNormalScreen,
        [FLOWS.WORDPRESS_IA]: WpIaScreen,
        [FLOWS.SITE_BUILDER]: isBRServer ? siteBuilderSuccessBr : siteBuilderSuccessEs,
        [FLOWS.OTHER_TOOLS]: OtherToolsScreen,
      };

      return rules[currentFlow];
    };

    return {
      locales,
      buttonsProps,
      imageSrc: getImage(),
      cleanUp,
    };
  }, [
    onboardingLocale,
    currentHosting.domain,
    selectedObject,
    routesLocale.sites,
    currentFlow,
    history,
    cleanUp,
    otherToolsRedirect,
    siteBuilderSso,
    sitebuilderLoading,
  ]);

  const exitConfirmModalProps = useCallback(() => ({
    onCloseModal: () => setDisplayExitConfirmModal(false),
    title: onboardingLocale.siteBuilderV2.exitConfirmModal.title,
    description: onboardingLocale.siteBuilderV2.exitConfirmModal.description,
    buttonsProps: [
      {
        variant: 'tertiary',
        label: onboardingLocale.siteBuilderV2.exitConfirmModal.exitButtonLabel,
        size: 'medium2',
        testId: 'button-exit-confirm',
        onClick: handleGoBack,
      },
      {
        variant: 'primary',
        label: onboardingLocale.siteBuilderV2.exitConfirmModal.cancelButtonLabel,
        size: 'medium2',
        testId: 'button-cancel',
        onClick: () => setDisplayExitConfirmModal(false),
      },
    ],
  }), [
    handleGoBack,
    onboardingLocale.siteBuilderV2.exitConfirmModal,
    setDisplayExitConfirmModal,
  ]);

  const hasSelectedTool = !!otherToolsRedirect;

  const advancedModeModalProps = useCallback(() => ({
    onCloseModal: () => setDisplayAdvancedModeModal(false),
    title: onboardingLocale.chooseSiteOption.advancedModeModal.title,
    description: onboardingLocale.chooseSiteOption.advancedModeModal.description,
    buttonsProps: [
      {
        variant: 'tertiary',
        label: onboardingLocale.chooseSiteOption.advancedModeModal.exitButtonLabel,
        size: isMobile ? 'small' : 'medium2',
        testId: 'button-exit-confirm',
        onClick: () => setDisplayAdvancedModeModal(false),
      },
      {
        variant: 'primary',
        label: onboardingLocale.chooseSiteOption.advancedModeModal.confirmButtonLabel,
        size: isMobile ? 'small' : 'medium2',
        testId: 'button-confirm',
        onClick: () => {
          handleRegisterHostingOnboarding();
          setCurrentFlow(FLOWS.OTHER_TOOLS);
          onboardingAnalytics.initialStep.accessOtherTools();
          setCurrentStep(STEPS.SELECT_DOMAIN);
          setDisplayAdvancedModeModal(false);
        },
      },
    ],
  }), [
    onboardingLocale.chooseSiteOption.advancedModeModal,
    setCurrentFlow,
    setCurrentStep,
    isMobile,
    handleRegisterHostingOnboarding,
  ]);

  const normalModeModalProps = useCallback(() => ({
    onCloseModal: () => setDisplayNormalModeModal(false),
    title: onboardingLocale.chooseSiteOption.normalModeModal.title,
    description: onboardingLocale.chooseSiteOption.normalModeModal.description,
    buttonsProps: [
      {
        variant: 'tertiary',
        label: onboardingLocale.chooseSiteOption.normalModeModal.exitButtonLabel,
        size: isMobile ? 'small' : 'medium2',
        testId: 'button-exit-confirm',
        onClick: () => setDisplayNormalModeModal(false),
      },
      {
        variant: 'primary',
        label: onboardingLocale.chooseSiteOption.normalModeModal.confirmButtonLabel,
        size: isMobile ? 'small' : 'medium2',
        testId: 'button-confirm',
        onClick: () => {
          handleRegisterHostingOnboarding();
          setCurrentFlow(FLOWS.WORDPRESS);
          onboardingAnalytics.initialStep.accessWordpressDefault();
          setCurrentStep(STEPS.SELECT_DOMAIN);
          setDisplayNormalModeModal(false);
        },
      },
    ],
  }), [
    onboardingLocale.chooseSiteOption.normalModeModal,
    setCurrentFlow,
    setCurrentStep,
    isMobile,
    handleRegisterHostingOnboarding,
  ]);

  const getChooseWpMigrationStep = useCallback(() => {
    const buttonsProps = {
      middleButton: {
        testId: 'toggleTempDomain',
        variant: 'tertiary',
        label: onboardingLocale.chooseWpMigrationStep.continueLater,
        onClick: () => {
          handleGoBack();
          dispatchClmEvent({ action: 'click-create-site-or-migrate-wordpress-later', finished: true });
          onboardingAnalytics.initialStep.doItLater();
        },
      },
    };

    const options = [
      {
        ...onboardingLocale.chooseWpMigrationStep.options[0],
        cta: {
          ...onboardingLocale.chooseWpMigrationStep.options[0].cta,
          action: () => {
            setCurrentStep(STEPS.CHOOSE_SITE_OPTION);
            dispatchClmEvent({ action: 'click-create-site', finished: false });
            onboardingAnalytics.initialStep.chooseCreateSiteOption();
          },
        },
      },
      {
        ...onboardingLocale.chooseWpMigrationStep.options[1],
        cta: {
          ...onboardingLocale.chooseWpMigrationStep.options[1].cta,
          action: () => {
            setCurrentFlow(FLOWS.WORDPRESS_MIGRATION);
            setCurrentStep(STEPS.SELECT_DOMAIN);
            dispatchClmEvent({ action: 'click-migrate-wordpress', finished: false });
            onboardingAnalytics.initialStep.chooseMigrateSiteOption();
          },
        },
      },
    ];

    return {
      title: onboardingLocale.chooseWpMigrationStep.title,
      options,
      buttonsProps,
    };
  }, [
    onboardingLocale,
    handleGoBack,
    setCurrentStep,
    setCurrentFlow,
    dispatchClmEvent,
  ]);

  const getWordpressMigrationProps = useCallback(() => ({
    hostingId: currentHosting.hosting_id || selectedObject.hosting_id,
    domain: currentHosting.domain || selectedObject.domain || selectedObject.selectedDomain,
    origin: 'onboarding',
    exitMigrationFlow: () => setCurrentStep(STEPS.SELECT_DOMAIN),
    cleanUp,
  }), [currentHosting, selectedObject, setCurrentStep, cleanUp]);

  const handleSyncPreviewWithAiBuilder = useCallback(() => {
    const currentBuilderAddonId = (currentHosting && currentHosting.builder_addon_id) ? currentHosting.builder_addon_id : null;
    const builderAddonIdByHostingId = getBuilderAddonIdByHostingId(currentHosting.hosting_id);
    const recentProvisionedBuilderAddonId = onboardingBuilderState.provisioning.builderAddonId;
    const builderAddonId = currentBuilderAddonId || builderAddonIdByHostingId || recentProvisionedBuilderAddonId;
    const selectedObjectDomain = currentHosting && currentHosting.domain;

    const requestProps = {
      builderAddonId,
      domain: selectedObjectDomain,
    };

    requestSyncPreviewWithAiBuilder({ ...requestProps });
  }, [
    currentHosting,
    getBuilderAddonIdByHostingId,
    onboardingBuilderState.provisioning.builderAddonId,
    requestSyncPreviewWithAiBuilder,
  ]);

  const handleCreateSiteWithAiBuilder = useCallback(({
    type,
    templateId = null,
    projectData = null,
  }) => {
    const selectedObjectDomain = currentHosting && currentHosting.domain;
    const currentBuilderAddonId = (currentHosting && currentHosting.builder_addon_id) ? currentHosting.builder_addon_id : null;
    const builderAddonIdByHostingId = getBuilderAddonIdByHostingId(currentHosting.hosting_id);
    const recentProvisionedBuilderAddonId = onboardingBuilderState.provisioning.builderAddonId;

    const createSiteWithAiBuilder = ({ builderAddonId }) => {
      updateOnboardingSteps({ forced: true, finished: true });

      const requestProps = {
        builderAddonId,
        domain: selectedObjectDomain,
        type,
      };

      if (templateId) {
        requestProps.templateId = templateId;
      }

      if (projectData) {
        requestProps.projectData = projectData;
      }

      if (!onboardingHgBuilderPreview || templateId) {
        requestCreateSiteWithAiBuilder({ ...requestProps });
        return;
      }

      requestCreatePreviewWithAiBuilder({ ...requestProps });
    };

    if (currentBuilderAddonId || builderAddonIdByHostingId || recentProvisionedBuilderAddonId) {
      createSiteWithAiBuilder({ builderAddonId: currentBuilderAddonId || builderAddonIdByHostingId || recentProvisionedBuilderAddonId });
    } else {
      provisioningSitebuilderOnHosting({ hostingId: currentHosting.hosting_id, callback: createSiteWithAiBuilder });
    }
  }, [
    currentHosting,
    getBuilderAddonIdByHostingId,
    updateOnboardingSteps,
    requestCreateSiteWithAiBuilder,
    provisioningSitebuilderOnHosting,
    onboardingBuilderState.provisioning.builderAddonId,
    onboardingHgBuilderPreview,
    requestCreatePreviewWithAiBuilder,
  ]);

  useEffect(() => {
    if (userDomainsList.length === 1) {
      const getPackageId = userDomainsList[0].package_id;
      setCurrentHosting(prev => ({
        ...prev,
        package_id: getPackageId,
      }));
    }
  }, [userDomainsList, setCurrentHosting]);

  const getAiBuilderMyBusinessProps = useCallback(() => {
    const onContinue = ({ projectData: newProjectData }) => {
      siteBuilderAiAnalytics.clickCreateMySite();
      setProjectData(newProjectData);

      handleCreateSiteWithAiBuilder({ type: 'business-project', projectData: newProjectData });
    };

    const onGoBack = () => {
      setCurrentStep(STEPS.SITE_BUILDER_V2);
    };

    const onChangeInput = (value) => {
      dispatch(onboardingActions.sitebuilder.business.request(value));
    };

    return {
      locales: onboardingLocale.aiBuilderMyBusiness,
      onContinue,
      onGoBack,
      onChangeInput,
      redirectSuccessPageAiBuilder,
      businessList: onboardingBuilderState.business,
      builderProvisioningLoading: onboardingBuilderState.provisioning.loading,
      createSiteState: aiBuilderState.createSite,
      createPreviewLoading,
      createPreviewStatus,
      onboardingHgBuilderPreview,
      redirectPreviewPage,
    };
  }, [
    onboardingLocale.aiBuilderMyBusiness,
    aiBuilderState.createSite,
    onboardingBuilderState.business,
    onboardingBuilderState.provisioning.loading,
    dispatch,
    setCurrentStep,
    redirectSuccessPageAiBuilder,
    handleCreateSiteWithAiBuilder,
    createPreviewLoading,
    createPreviewStatus,
    onboardingHgBuilderPreview,
    redirectPreviewPage,
  ]);

  const getAiBuilderCreateSiteProps = useCallback(() => {
    const onContinue = ({ projectData: newProjectData }) => {
      setProjectData(newProjectData);
      handleCreateSiteWithAiBuilder({ type: 'ai-project', projectData: newProjectData });
    };

    const onGoBack = () => {
      setCurrentStep(STEPS.SITE_BUILDER_V2);
    };

    return {
      createSiteState: aiBuilderState.createSite,
      builderProvisioningLoading: onboardingBuilderState.provisioning.loading,
      userCountry,
      onContinue,
      redirectSuccessPageAiBuilder,
      onGoBack,
      locales: onboardingLocale.aiBuilderCreateSite,
      createPreviewLoading,
      createPreviewStatus,
      onboardingHgBuilderPreview,
      redirectPreviewPage,
    };
  }, [
    onboardingLocale.aiBuilderCreateSite,
    onboardingBuilderState.provisioning.loading,
    userCountry,
    handleCreateSiteWithAiBuilder,
    aiBuilderState.createSite,
    redirectSuccessPageAiBuilder,
    setCurrentStep,
    createPreviewLoading,
    createPreviewStatus,
    onboardingHgBuilderPreview,
    redirectPreviewPage,
    setProjectData,
  ]);

  const getAiBuilderWithTemplateProps = useCallback(() => {
    const openTemplate = ({ templateId }) => {
      handleCreateSiteWithAiBuilder({ type: 'template-project', templateId });
    };

    const onGoBack = () => {
      setCurrentStep(STEPS.SITE_BUILDER_V2);
    };

    const handleSearchTerm = ({ term, setCategorieAsDefault }) => {
      dispatch(onboardingActions.sitebuilder.templates.searchTemplatesByTerm({ term, setCategorieAsDefault }));
    };

    const handleBackToDefault = () => {
      dispatch(onboardingActions.sitebuilder.templates.backToDefault());
    };

    return {
      openTemplate,
      redirectSuccessPageAiBuilder,
      locales: onboardingLocale.aiBuilderWithTemplate,
      createSiteState: aiBuilderState.createSite,
      createWithTemplatesState: onboardingBuilderState.createWithTemplates,
      builderProvisioningLoading: onboardingBuilderState.provisioning.loading,
      getTemplateCategories: getBuilderTemplateCategories,
      getTemplates: getBuilderTemplates,
      onGoBack,
      handleSearchTerm,
      handleBackToDefault,
    };
  }, [
    getBuilderTemplateCategories,
    getBuilderTemplates,
    onboardingBuilderState.provisioning.loading,
    onboardingBuilderState.createWithTemplates,
    aiBuilderState.createSite,
    onboardingLocale,
    redirectSuccessPageAiBuilder,
    handleCreateSiteWithAiBuilder,
    setCurrentStep,
    dispatch,
  ]);

  const getSiteBuilderV2Props = useCallback(() => {
    const cardsLocale = onboardingLocale.siteBuilderV2.cardsList;

    const onGoBack = () => {
      siteBuilderAiAnalytics.clickGoBackMethodSelection();
      setCurrentStep(STEPS.CHOOSE_WP_MIGRATION);
    };

    const cards = [
      {
        id: 'ia_builder_my_business',
        icon: <IconGoogleBusiness color="primaryBlue" size="lg" />,
        title: cardsLocale[STEPS.IA_BUILDER_MY_BUSINESS].title,
        desc: cardsLocale[STEPS.IA_BUILDER_MY_BUSINESS].desc,
        onClick: () => {
          setTypeProject('business-project');
          siteBuilderAiAnalytics.clickCreateWithMyBusiness();
          setCurrentStep(STEPS.IA_BUILDER_MY_BUSINESS);
        },
      },
      {
        id: 'ia_builder_create_site',
        icon: <IconAiStar color="primaryBlue" size="md" />,
        title: cardsLocale[STEPS.IA_BUILDER_CREATE_SITE].title,
        desc: cardsLocale[STEPS.IA_BUILDER_CREATE_SITE].desc,
        onClick: () => {
          setTypeProject('ai-project');
          siteBuilderAiAnalytics.clickCreateWithYourIdeas();
          setCurrentStep(STEPS.IA_BUILDER_CREATE_SITE);
        },
      },
      {
        id: 'ia_builder_with_template',
        icon: <IconPicture color="primaryBlue" size="md" />,
        title: cardsLocale[STEPS.IA_BUILDER_WITH_TEMPLATE].title,
        desc: cardsLocale[STEPS.IA_BUILDER_WITH_TEMPLATE].desc,
        onClick: () => {
          setTypeProject('template-project');
          siteBuilderAiAnalytics.clickCreateFromTemplate();
          setCurrentStep(STEPS.IA_BUILDER_WITH_TEMPLATE);
        },
      },
    ];

    return {
      siteBuilderV2Locale: onboardingLocale.siteBuilderV2,
      setCurrentFlow,
      cards,
      onGoBack,
    };
  }, [onboardingLocale, setCurrentFlow, setCurrentStep]);

  const getAgentFactorySuccessProps = useCallback(() => {
    const builderSsoState = sitesReducer.sitebuilder.sso;
    const domains = (sitesReducer.list && sitesReducer.list.map(item => item.package_id)) || [];

    const popupBlockedAction = () => {
      setPopupBlockedModalOnCookie({ origin: POPUP_BLOCKED_ORIGIN.SITE_CREATED_WITH_HG_BUILDER });
    };

    const handleRequestBuilderSso = (() => {
      dispatch(sitesActions.builderSso.request({ builderAddonId: builderSsoState.builderAddonId, domain: builderSsoState.domain, popupBlockedAction }));
    });

    return {
      locales: onboardingLocale.siteBuilderV2.factoryAgent,
      isMobile,
      domainsList: domains,
      loading: builderSsoState.loading,
      handleRequestBuilderSso,
      createPreviewLoading,
    };
  }, [
    dispatch,
    onboardingLocale,
    sitesReducer.list,
    sitesReducer.sitebuilder,
    setPopupBlockedModalOnCookie,
    createPreviewLoading,
    isMobile,
  ]);

  const getSiteBuilderPreviewProps = useCallback(() => {
    const handleGenerateNewSite = () => {
      handleCreateSiteWithAiBuilder({ type: typeProject, projectData });
    };

    return {
      locales: onboardingLocale.sitebuilderPreview,
      projectUid,
      createPreviewLoading,
      handleGenerateNewSite,
      handleSyncPreviewWithAiBuilder,
      builderProvisioningLoading: onboardingBuilderState.provisioning.loading,
      createSiteState: aiBuilderState.createSite,
      redirectSuccessPageAiBuilder,
    };
  }, [
    onboardingLocale,
    projectUid,
    createPreviewLoading,
    handleSyncPreviewWithAiBuilder,
    handleCreateSiteWithAiBuilder,
    projectData,
    onboardingBuilderState.provisioning.loading,
    aiBuilderState.createSite,
    redirectSuccessPageAiBuilder,
    typeProject,
  ]);

  const runSentToZenviaOnSuccess = useCallback(() => {
    sentToZenviaOnSuccess({
      currentStep,
      usingTempDomain,
      sentToZenvia,
      flowCreateSiteTemporaryDomain,
      currentHosting,
      createdTemporaryDomain: domainsReducer.createdTemporaryDomain,
      triggerSiteCreatedWithTempDomain,
      setsentToZenvia,
    });
  }, [
    currentStep,
    usingTempDomain,
    currentHosting,
    domainsReducer.createdTemporaryDomain,
    triggerSiteCreatedWithTempDomain,
    sentToZenvia,
    setsentToZenvia,
    flowCreateSiteTemporaryDomain,
  ]);

  useEffect(() => {
    runSentToZenviaOnSuccess();
  }, [runSentToZenviaOnSuccess]);

  const handleRequestMonarx = useCallback(() => {
    if (currentStep === STEPS.SUCCESS && features.gator_protect && !monarxAlreadyActivated) {
      setMonarxAlreadyActivated(true);
      getMonarx({
        hostings,
        selectedObject,
        gatorProtectPlans,
      });
    }
  }, [
    currentStep,
    features,
    monarxAlreadyActivated,
    getMonarx,
    hostings,
    selectedObject,
    gatorProtectPlans,
  ]);

  useEffect((() => {
    handleRequestMonarx();
  }), [handleRequestMonarx]);

  const renderStep = {
    [STEPS.CHOOSE_WP_MIGRATION]: <ChooseWpMigrationStep {...getChooseWpMigrationStep()} />,
    [STEPS.CHOOSE_SITE_OPTION]: <ChooseSiteOption {...getChooseSiteOptionProps()} />,
    [STEPS.SELECT_DOMAIN]: <ChooseDomainStep {...getChooseDomainProps()} />,
    [STEPS.WORDPRESS_INSTALL]: <WordPressInstall {...getWordPressInstallProps()} />,
    [STEPS.BUY_DOMAIN]: <DomainNotRegistered {...getDomainNotRegisteredProps()} />,
    [STEPS.EXTERNAL_DOMAIN]: <ExternalDomain {...getExternalDomainProps()} />,
    [STEPS.WORDPRESS_MIGRATION]: <WordpressMigration {...getWordpressMigrationProps()} />,
    [STEPS.IA_BUILDER_MY_BUSINESS]: <AiBuilderMyBusiness {...getAiBuilderMyBusinessProps()} />,
    [STEPS.IA_BUILDER_CREATE_SITE]: <AiBuilderCreateSite {...getAiBuilderCreateSiteProps()} />,
    [STEPS.IA_BUILDER_WITH_TEMPLATE]: <AiBuilderWithTemplate {...getAiBuilderWithTemplateProps()} />,
    [STEPS.SITE_BUILDER_V2]: <SiteBuilderV2 {...getSiteBuilderV2Props()} />,
    [STEPS.SITE_BUILDER_PREVIEW]: <SiteBuilderPreview {...getSiteBuilderPreviewProps()} />,
    [STEPS.SUCCESS]: (() => {
      if (currentFlow === FLOWS.OTHER_TOOLS && !hasSelectedTool) {
        return <OtherToolsSuccess {...getSuccessOtherToolsProps()} />;
      }
      if (currentFlow === FLOWS.AGENT_FACTORY) {
        return <SiteBuilderSuccess {...getAgentFactorySuccessProps()} />;
      }
      return <GenericSuccess {...getGenericSuccessProps()} />;
    })(),
  };

  if (!sitesOnboardingEnabled) {
    return (<Redirect to={routesLocale.home} />);
  }

  return (
    <>

      {(!!blockedWindowUrl) && (
        renderBlockedWindowModal({
          url: blockedWindowUrl,
          closeModal: handleCloseBlockedWindowModal,
          redirect: redirectToPortal,
        })
      )}

      {displayExitConfirmModal && <ExitConfirmModal {...exitConfirmModalProps()} />}
      {displayNormalModeModal && <ConfirmModal {...normalModeModalProps()} />}
      {displayAdvancedModeModal && <ConfirmModal {...advancedModeModalProps()} />}

      <Styles.OnboardingHandlerWrapper id="OnboardingHandlerWrapper" $isInitialStep={initialStepStyle} $isLoading={isLoading}>
        <Styles.LogoRow>
          <Styles.BackWrapper>
            {currentStep === STEPS.CHOOSE_SITE_OPTION && (
              <IconButton
                testId="site-builder-v2-button-back"
                icon="IconArrow"
                color="lowDark"
                size="sm"
                onClick={() => onCloseWizard({ handleGoBack })}
              />
            )}
            <Styles.Logo $show={showLogo}>
              <HgLogoV2 newMenu />
            </Styles.Logo>
          </Styles.BackWrapper>
          <IconButton
            icon="IconClose"
            color="lowDark"
            size="sm"
            onClick={() => {
              handleCloseOnBoarding();
              dispatchClmEvent({ action: 'click-close-create-site', finished: true });
            }}
          />
        </Styles.LogoRow>
        <Styles.Container $isLoading={isLoading}>
          {isLoading
            ? <Styles.IconLoadingWrapper><IconLoading /></Styles.IconLoadingWrapper>
            : renderStep[currentStep]
          }
        </Styles.Container>
      </Styles.OnboardingHandlerWrapper>
    </>
  );
};

export default OnboardingHandler;
